import {
  FETCH_CATALOG_FAILURE,
  FETCH_CATALOG_REQUEST,
  FETCH_CATALOG_SUCCESS,
  FETCH_COURSE_DETAILS_FAILURE,
  FETCH_COURSE_DETAILS_REQUEST,
  FETCH_COURSE_DETAILS_SUCCESS,
} from "../Actions/types";

const initialState = {
  loading: false,
  courses: [],
  courseDetails: {},
  titles: [],
  levels: [],
  error: "",
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COURSE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COURSE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        courseDetails: action.payload,
        error: "",
      };
    case FETCH_COURSE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        courseDetails: {},
        error: action.payload,
      };
    case FETCH_CATALOG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: action.payload.courses,
        titles: action.payload.titles,
        levels: action.payload.levels,
        error: "",
      };
    case FETCH_CATALOG_FAILURE:
      return {
        ...state,
        loading: false,
        courses: [],
        titles: [],
        levels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default courseReducer;
